import React from 'react';
import TagsManager from '../tags-manager';

const TagsTab = () => (
  <div>
    <TagsManager />
  </div>
);

export default TagsTab;



/** WEBPACK FOOTER **
 ** ./src/containers/team-manager/tags-tab.js
 **/